module.exports = __webpack_public_path__ + "img/item3.318d4739.png";